import PropTypes from 'prop-types';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import logo from 'src/static/vectors/logo-block.svg';
import './ErrorBoundary.sass';

interface MyProps {
	children: React.ReactNode;
	fallback?: ReactNode;
}
interface MyState {
	hasError: boolean;
	details?: object;
}
class ErrorBoundary extends React.Component<MyProps, MyState> {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static propTypes = {
		children: PropTypes.node
	};

	static getDerivedStateFromError(error) {
		return {
			hasError: true,
			details: error
		};
	}

	handleReload = () => {
		window.setTimeout(() => window.location.reload(), 0);
	};

	render() {
		if (this.state.hasError) {
			if (this.props.fallback) return this.props.fallback;
			return (
				<div className="error page">
					<header id="masthead">
						<img src={logo} alt="logo" />
					</header>
					<div className="error-illustration" />
					<section>
						<h1>
							<FormattedMessage id="error.title" />
						</h1>
						<p>
							<FormattedMessage id="error" />
						</p>
						{__DEV__ && this.state.details && <div>{this.state.details.toString()}</div>}
						<Link to="/" className="button" onClick={this.handleReload}>
							<FormattedMessage id="reload" />
						</Link>
					</section>
				</div>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
